"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ERC20Token_1 = __importDefault(require("./ERC20Token"));
const utils_1 = require("../utils");
class HatchConfig {
    constructor(data, contractCache) {
        this.id = data.id;
        this.token = new ERC20Token_1.default(data.token, contractCache, 'token');
        this.reserve = data.reserve;
        this.beneficiary = data.beneficiary;
        this.contributionToken = new ERC20Token_1.default(data.contributionToken, contractCache, 'contributionToken');
        this.minGoal = data.minGoal;
        this.maxGoal = data.maxGoal;
        this.period = data.period;
        this.exchangeRate = data.exchangeRate;
        this.vestingCliffPeriod = data.vestingCliffPeriod;
        this.vestingCompletePeriod = data.vestingCompletePeriod;
        this.supplyOfferedPct = data.supplyOfferedPct;
        this.fundingForBeneficiaryPct = data.fundingForBeneficiaryPct;
        this.openDate = data.openDate;
        this.vestingCliffDate = data.vestingCliffDate;
        this.vestingCompleteDate = data.vestingCompleteDate;
        this.totalRaised = data.totalRaised;
        this.state = data.state;
        this.PPM = data.PPM;
        const state = utils_1.calculateHatchState(this, data.state);
        this.state = state.toUpperCase();
    }
}
exports.default = HatchConfig;
//# sourceMappingURL=HatchConfig.js.map